import { render, staticRenderFns } from "./mantenimiento.vue?vue&type=template&id=72a701c8&scoped=true"
import script from "./mantenimiento.vue?vue&type=script&lang=js"
export * from "./mantenimiento.vue?vue&type=script&lang=js"
import style0 from "./mantenimiento.vue?vue&type=style&index=0&id=72a701c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a701c8",
  null
  
)

export default component.exports